export function getHoursMinutesSecondsText(totalSeconds?: number) {

    ///console.log(`totalSeconds: ${totalSeconds}`);

    if (totalSeconds === null || totalSeconds === undefined) {
        return "";
    }

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    //return `${hours.toString}:${minutes}:${seconds}`;
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = seconds.toString().padStart(2, '0');
  
    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}